module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.displayLoading),
      expression: "displayLoading"
    }],
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "card  pt-20"
  }, [_c('span', {
    staticClass: "chartTitle"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('bar', {
    attrs: {
      "range": _vm.dateRange,
      "localName": _vm.localName,
      "time": _vm.time,
      "url": _vm.url,
      "addMonths": _vm.addMonths,
      "type": _vm.type,
      "type_from": _vm.type_from,
      "amountValue": _vm.amountValue
    },
    on: {
      "loader": _vm.loadingEvent
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c9f08568!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UIComponents/Charts/BarChart.vue
// module id = 453
// module chunks = 1